export const Config = {
  localToken: process.env.REACT_APP_LOCAL_TOKEN ?? '',
  localUserId: process.env.REACT_APP_LOCAL_USER_ID ?? '',
  useLocalAuthProvider: process.env.REACT_APP_USE_LOCAL_AUTH_PROVIDER === 'true',
};
